// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"59df9192","377":"14ad7145","453":"e19a7d6f","455":"a7954f0f","977":"89e9f6a2"}[chunkId] + ".chunk.js";
};